// import React, { useState, useEffect } from 'react';
// import { X, ChevronRight, ChevronLeft, ChevronDown, ChevronUp } from 'lucide-react';
// import styles from './RoleModal.module.css';

// interface ModulePermission {
//     module_id?: string;
//     submodule_id?: string;
//     privilege_id: string;
// }

// interface Submodule {
//     id: string;
//     name: string;
//     label: string;
//     privileges: string[];
// }

// interface Module {
//     id: string;
//     name: string;
//     label: string;
//     submodules: Submodule[];
//     privileges: string[];
// }

// interface RoleModalProps {
//     isOpen: boolean;
//     onClose: () => void;
//     onSubmit: (data: { name: string; description: string; modules: ModulePermission[] }) => void;
//     initialData?: { name: string; description: string; id?: string };
//     title: string;
//     modules?: Array<Module>;
//     privileges?: Array<{ id: string; name: string }>;
// }

// const RoleModal: React.FC<RoleModalProps> = ({
//     isOpen,
//     onClose,
//     onSubmit,
//     initialData,
//     title,
//     modules = [],
//     privileges = []
// }) => {
//     const [step, setStep] = useState(1);
//     const [name, setName] = useState('');
//     const [description, setDescription] = useState('');

//     // Store selected privileges:
//     // { "module_id": ["priv1", "priv2"], "submodule_id": ["priv1"] }
//     const [selectedPermissions, setSelectedPermissions] = useState<Record<string, string[]>>({});

//     const [errors, setErrors] = useState<{ name?: string; description?: string }>({});
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [loadingRoleData, setLoadingRoleData] = useState(false);

//     // Accordion state: map of module_id -> boolean (isExpanded)
//     const [expandedModules, setExpandedModules] = useState<Record<string, boolean>>({});

//     useEffect(() => {
//         if (isOpen && initialData) {
//             setName(initialData.name);
//             setDescription(initialData.description || '');
//             if (initialData.id) {
//                 // We also check privileges.length to ensure metadata is ready for mapping
//                 if (privileges && privileges.length > 0) {
//                     loadRoleModules(initialData.id);
//                 }
//             }
//         } else if (!isOpen) {
//             setName('');
//             setDescription('');
//             setSelectedPermissions({});
//             setExpandedModules({});
//             setStep(1);
//             setErrors({});
//             setLoadingRoleData(false);
//         }
//     }, [initialData?.id, isOpen, privileges]);

//     const loadRoleModules = async (roleId: string) => {
//         setLoadingRoleData(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/roles/${roleId}/modules`, {
//                 headers: {
//                     'Authorization': `Bearer ${localStorage.getItem('access_token')}`
//                 }
//             });
//             if (response.ok) {
//                 const data = await response.json();
//                 const permMap: Record<string, string[]> = {};

//                 data.modules.forEach((m: any) => {
//                     const moduleId = m.module_id;

//                     if (!permMap[moduleId]) {
//                         permMap[moduleId] = [];
//                     }

//                     // 🔥 map privilege NAMES → IDs
//                     const modulePrivIds = (m.privileges || [])
//                         .map((name: string) => {
//                             const match = privileges.find(p => p.name === name);
//                             return match?.id;
//                         })
//                         .filter(Boolean);

//                     permMap[moduleId] = modulePrivIds;

//                     // 🔥 handle submodules
//                     (m.submodules || []).forEach((sub: any) => {
//                         const subId = sub.submodule_id;

//                         const subPrivIds = (sub.privileges || [])
//                             .map((name: string) => {
//                                 const match = privileges.find(p => p.name === name);
//                                 return match?.id;
//                             })
//                             .filter(Boolean);

//                         permMap[subId] = subPrivIds;
//                     });
//                 });
//                 setSelectedPermissions(permMap);
//             }
//         } catch (error) {
//             console.error('Failed to load role modules:', error);
//         } finally {
//             setLoadingRoleData(false);
//         }
//     };

//     const validateName = (value: string): string | undefined => {
//         if (!value.trim()) return 'Role name is required';
//         if (value.trim().length > 50) return 'Role name cannot exceed 50 characters';
//         return undefined;
//     };

//     const validateDescription = (value: string): string | undefined => {
//         if (value.trim().length > 300) return 'Description cannot exceed 300 characters';
//         return undefined;
//     };

//     const handleNameChange = (value: string) => {
//         const upperValue = value.toUpperCase();
//         setName(upperValue);
//         const error = validateName(upperValue);
//         setErrors(prev => ({ ...prev, name: error }));
//     };

//     const handleDescriptionChange = (value: string) => {
//         setDescription(value);
//         const error = validateDescription(value);
//         setErrors(prev => ({ ...prev, description: error }));
//     };

//     const handleNext = () => {
//         const nameError = validateName(name);
//         if (nameError) {
//             setErrors({ name: nameError });
//             return;
//         }
//         setErrors({});
//         setStep(2);
//     };

//     const handleBack = () => setStep(1);

//     const toggleModule = (moduleId: string) => {
//         setExpandedModules(prev => ({
//             ...prev,
//             [moduleId]: !prev[moduleId]
//         }));
//     };
// const PRIVILEGE_ORDER = ["READ", "WRITE", "UPDATE", "DELETE"];

// const togglePermission = (
//   targetId: string,
//   privilegeId: string,
//   availablePrivilegeIds: string[]
// ) => {
//   setSelectedPermissions(prev => {
//     const current = prev[targetId] || [];

//     // Map ID → NAME
//     const privilege = privileges.find(p => p.id === privilegeId);
//     if (!privilege) return prev;

//     const name = privilege.name.toUpperCase();

//     let updated = [...current];

//     // ---------------- NO ACCESS ----------------
//     if (privilegeId === "NO_ACCESS") {
//       return { ...prev, [targetId]: [] };
//     }

//     // ---------------- ADMIN ----------------
//     if (name === "ADMIN") {
//       const isSelecting = !current.includes(privilegeId);

//       return {
//         ...prev,
//         [targetId]: isSelecting ? availablePrivilegeIds : []
//       };
//     }

//     // ---------------- CRUD LOGIC ----------------
//     if (PRIVILEGE_ORDER.includes(name)) {
//       const index = PRIVILEGE_ORDER.indexOf(name);

//       const selectedNames = current
//         .map(id => privileges.find(p => p.id === id)?.name?.toUpperCase())
//         .filter(Boolean);

//       const isSelecting = !selectedNames.includes(name);

//       if (isSelecting) {
//         // ✅ Select all lower hierarchy
//         const required = PRIVILEGE_ORDER.slice(0, index + 1);

        
//        const requiredIds = availablePrivilegeIds.filter(id => {
//   const p = privileges.find(x => x.id === id);
//   return p && required.includes(p.name.toUpperCase());
// });

//         updated = Array.from(new Set([...current, ...requiredIds]));
//       } else {
//         // ❌ Remove this and higher
//         const toRemove = PRIVILEGE_ORDER.slice(index);

//       const removeIds = availablePrivilegeIds.filter(id => {
//   const p = privileges.find(x => x.id === id);
//   return p && toRemove.includes(p.name.toUpperCase());
// });

//         updated = current.filter(id => !removeIds.includes(id));
//       }
//     }

//     // ---------------- EXPORT / SHARE ----------------
//     if (name === "EXPORT" || name === "SHARE") {
//       const read = privileges.find(p => p.name === "READ");

//       if (read && !current.includes(read.id)) {
//         updated.push(read.id);
//       }

//       if (current.includes(privilegeId)) {
//         updated = updated.filter(id => id !== privilegeId);
//       } else {
//         updated.push(privilegeId);
//       }
//     }

//     return {
//       ...prev,
//       [targetId]: updated
//     };
//   });
// };

//     const handleSubmit = async (e: React.FormEvent) => {
//         e.preventDefault();
//         const nameError = validateName(name);
//         if (nameError) {
//             setErrors({ name: nameError });
//             setStep(1);
//             return;
//         }

//         const modulePermissions: ModulePermission[] = [];

//         modules.forEach(module => {
//             // Module level
//             const modPrivs = selectedPermissions[module.id] || [];
//             // modPrivs.forEach(pid => {
//             //     modulePermissions.push({ module_id: module.id, privilege_id: pid });
//             // });
//             modPrivs
//   .filter(pid => typeof pid === 'string' && pid.trim() !== '')
//   .forEach(pid => {
//     modulePermissions.push({
//       module_id: module.id,
//       privilege_id: pid
//     });
//   });
//             // Submodule level
//             if (module.submodules) {
//                 module.submodules.forEach(sub => {
//                     const subPrivs = selectedPermissions[sub.id] || [];
//                    subPrivs
//   .filter(pid => typeof pid === 'string' && pid.trim() !== '')
//   .forEach(pid => {
//     modulePermissions.push({
//       module_id: module.id,
//       submodule_id: sub.id,
//       privilege_id: pid
//     });
//   });
//                 });
//             }
//         });

//         setIsSubmitting(true);
//         try {
//             const cleaned = modulePermissions.filter(p => p.privilege_id);
// await onSubmit({
//   name: name.trim(),
//   description: description.trim(),
//   modules: cleaned
// });        } finally {
//             setIsSubmitting(false);
//         }
//     };

//     // Sort privileges to ensure consistent order: READ, WRITE (CREATE), UPDATE, DELETE, ...
//     // Map of name -> order index
//     const privOrder: Record<string, number> = {
//         'READ': 1,
//         'CREATE': 2,
//         'WRITE': 2,
//         'UPDATE': 3,
//         'DELETE': 4,
//         'EXPORT': 5,
//         'IMPORT': 6,
//         'SHARE': 7,
//         'ADMIN': 99
//     };

//     const sortedPrivileges = [...privileges].sort((a, b) => {
//         const orderA = privOrder[a.name.toUpperCase()] || 50;
//         const orderB = privOrder[b.name.toUpperCase()] || 50;
//         return orderA - orderB;
//     });

//     const getPrivilegeLabel = (name: string) => {
//         const upper = name.toUpperCase();
//         if (upper === 'CREATE') return 'Write'; // User requested "Write"
//         return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase(); // Title Case
//     };

//     const renderPrivilegeCheckboxes = (targetId: string, availablePrivilegeNames: string[]) => {
//         const selectedIds = selectedPermissions[targetId] || [];

//         // Filter global privileges to match what's available for this module/submodule
//         const available = sortedPrivileges.filter(p => availablePrivilegeNames.includes(p.name));

//         const isNoAccess = selectedIds.length === 0;

//         return (
//             <div className={styles.checkboxGroup}>
//                 <label className={styles.checkboxLabel}>
//                     <input
//                         type="checkbox"
//                         checked={isNoAccess}
//                         onChange={() => togglePermission(targetId, 'NO_ACCESS', [])}
//                         className={styles.checkboxInput}
//                     />
//                     <span className={styles.checkboxText}>No Access</span>
//                 </label>

//                 {available.map(priv => (
//                     <label key={priv.id} className={styles.checkboxLabel}>
//                         <input
//                             type="checkbox"
//                             checked={selectedIds.includes(priv.id)}
//                             onChange={() => togglePermission(targetId, priv.id, available.map(p => p.id))}
//                             className={styles.checkboxInput}
//                         />
//                         <span className={styles.checkboxText}>{getPrivilegeLabel(priv.name)}</span>
//                     </label>
//                 ))}
//             </div>
//         );
//     };

//     if (!isOpen) return null;

//     return (
//         <div className={styles.overlay} onClick={onClose}>
//             <div className={styles.content} onClick={(e) => e.stopPropagation()}>
//                 <div className={styles.header}>
//                     <h2>{title} {`- Step ${step} of 2`}</h2>
//                     <button className={styles.closeButton} onClick={onClose}>
//                         <X size={20} />
//                     </button>
//                 </div>
//                 <form className={styles.form} onSubmit={handleSubmit} onKeyDown={(e) => {
//     if (e.key === 'Enter') {
//       e.preventDefault();
//     }
//   }}>
//                     <div className={styles.formContent}>
//                         {step === 1 && (
//                             <>
//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>Role Name *</label>
//                                     <input
//                                         type="text"
//                                         className={`${styles.input} ${styles.inputUppercase}`}
//                                         value={name}
//                                         onChange={(e) => handleNameChange(e.target.value)}
//                                         required
//                                         placeholder="Enter role name"
//                                         maxLength={50}
//                                         style={{ borderColor: errors.name ? '#ef4444' : '#d1d5db' }}
//                                     />
//                                     {errors.name && <span className={styles.errorText}>{errors.name}</span>}
//                                     <span className={styles.charCount}>{name.length}/50 characters</span>
//                                 </div>
//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>Description</label>
//                                     <textarea
//                                         className={styles.textarea}
//                                         value={description}
//                                         onChange={(e) => handleDescriptionChange(e.target.value)}
//                                         placeholder="Enter role description"
//                                         maxLength={300}
//                                         rows={4}
//                                         style={{ borderColor: errors.description ? '#ef4444' : '#d1d5db' }}
//                                     />
//                                     {errors.description && <span className={styles.errorText}>{errors.description}</span>}
//                                     <span className={styles.charCount}>{description.length}/300 characters</span>
//                                 </div>
//                             </>
//                         )}

//                         {step === 2 && (
//                             <div className={styles.moduleAssignment}>
//                                 <p className={styles.moduleHint}>Assign privileges to modules and submodules</p>
//                                 {loadingRoleData ? (
//                                     <div className={styles.loadingContainer}>
//                                         <div className={styles.spinner}></div>
//                                         <p>Loading role permissions...</p>
//                                     </div>
//                                 ) : modules.length === 0 ? (
//                                     <p className={styles.noModules}>No modules available</p>
//                                 ) : (
//                                     <div className={styles.accordionContainer}>
//                                         {modules.map(module => {
//                                             const isExpanded = expandedModules[module.id];
//                                             const hasSubmodules = module.submodules && module.submodules.length > 0;
//                                             const modulePrivs = module.privileges || [];

//                                             // If no submodules, show flat layout with privileges in same row
//                                             if (!hasSubmodules) {
//                                                 return (
//                                                     <div key={module.id} className={styles.flatModuleItem}>
//                                                         <div className={styles.flatModuleRow}>
//                                                             <span className={styles.moduleLabel}>{module.label}</span>
//                                                             {renderPrivilegeCheckboxes(module.id, modulePrivs)}
//                                                         </div>
//                                                     </div>
//                                                 );
//                                             }

//                                             // If has submodules, show accordion layout
//                                             return (
//                                                 <div key={module.id} className={styles.accordionItem}>
//                                                     <div className={styles.accordionHeader} onClick={() => toggleModule(module.id)}>
//                                                         <div className={styles.accordionTitle}>
//                                                             <span className={styles.moduleLabel}>{module.label}</span>
//                                                         </div>
//                                                         <div className={styles.accordionArrow}>
//                                                             {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
//                                                         </div>
//                                                     </div>

//                                                     {isExpanded && (
//                                                         <div className={styles.accordionContent}>
//                                                             <div className={styles.submoduleList}>
//                                                                 {module.submodules.map(sub => (
//                                                                     <div key={sub.id} className={styles.submoduleItem}>
//                                                                         <label className={styles.submoduleLabel}>{sub.label}</label>
//                                                                         {renderPrivilegeCheckboxes(sub.id, sub.privileges || [])}
//                                                                     </div>
//                                                                 ))}
//                                                             </div>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             );
//                                         })}
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                     </div>

//                     <div className={styles.actions}>
//                         {step === 2 && (
//                             <button type="button" className={styles.backButton} onClick={handleBack}>
//                                 <ChevronLeft size={16} color="#64748b" /> Back
//                             </button>
//                         )}
//                         <button type="button" className={styles.cancelButton} onClick={onClose}>
//                             Cancel
//                         </button>
//                         {step === 1 ? (
//                             <button
//                                 type="button"
//                                 className={styles.nextButton}
//                                 onClick={(e) => { e.preventDefault(); handleNext(); }}
//                                 disabled={!name.trim() || !!errors.name}
//                             >
//                                 Next <ChevronRight size={16} color="#011926" />
//                             </button>
//                         ) : (
//                             <button type="submit" className={styles.submitButton} disabled={isSubmitting || loadingRoleData}>
//                                 {isSubmitting ? 'Saving...' : (initialData ? 'Update' : 'Create')}
//                             </button>
//                         )}
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default RoleModal;
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { X, ChevronRight, ChevronLeft, ChevronDown, ChevronUp } from 'lucide-react';
import styles from './RoleModal.module.css';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------
interface ModulePermission {
    module_id?: string;
    submodule_id?: string;
    privilege_id: string;
}

interface Submodule {
    id: string;
    name: string;
    label: string;
    privileges: string[];
}

interface Module {
    id: string;
    name: string;
    label: string;
    submodules: Submodule[];
    privileges: string[];
}

interface RoleModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: { name: string; description: string; modules: ModulePermission[] }) => void;
    initialData?: { name: string; description: string; id?: string };
    title: string;
    modules?: Module[];
    privileges?: Array<{ id: string; name: string }>;
}

// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------

/**
 * Strict CRUD hierarchy. Order matters: index = rank.
 * READ (0) < WRITE (1) < UPDATE (2) < DELETE (3)
 */
const CRUD_HIERARCHY = ['READ', 'WRITE', 'UPDATE', 'DELETE'] as const;
type CrudName = typeof CRUD_HIERARCHY[number];

const PRIV_DISPLAY_ORDER: Record<string, number> = {
    READ: 1,
    CREATE: 2,
    WRITE: 2,
    UPDATE: 3,
    DELETE: 4,
    EXPORT: 5,
    IMPORT: 6,
    SHARE: 7,
    ADMIN: 99,
};

// ---------------------------------------------------------------------------
// Pure helper — lives outside component so it is never re-created
// ---------------------------------------------------------------------------

/**
 * Returns the display label for a privilege name.
 * "CREATE" → "Write" to match previous UX expectation.
 */
function getPrivilegeLabel(name: string): string {
    const upper = name.toUpperCase();
    if (upper === 'CREATE') return 'Write';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

// ---------------------------------------------------------------------------
// Core toggle logic (pure function — easy to unit-test)
// ---------------------------------------------------------------------------

/**
 * Computes the next set of selected privilege IDs for a single target
 * (module or submodule) after toggling `privilegeId`.
 *
 * @param current           Currently selected privilege IDs for this target.
 * @param privilegeId       The ID being toggled (or the sentinel "NO_ACCESS").
 * @param availableIds      ALL privilege IDs that are valid for this target.
 * @param idToName          O(1) lookup map from privilege ID → uppercase name.
 * @param nameToId          O(1) lookup map from uppercase name → privilege ID.
 */
function computeNextPrivileges(
    current: string[],
    privilegeId: string,
    availableIds: string[],
    idToName: Map<string, string>
): string[] {

    const getName = (id: string) => idToName.get(id);

    const getIdByName = (name: string) =>
        availableIds.find(id => getName(id) === name);

    // 🚫 NO ACCESS
    if (privilegeId === 'NO_ACCESS') {
        return [];
    }

    const privName = getName(privilegeId);
    if (!privName) return current;

    const next = new Set(current);

    // 🔥 ADMIN (FULL CONTROL)
    if (privName === 'ADMIN') {
        const isSelecting = !next.has(privilegeId);
        return isSelecting ? [...availableIds] : [];
    }

    // 🔥 CRUD
    const index = CRUD_HIERARCHY.indexOf(privName as any);

    if (index !== -1) {
        const isSelecting = !next.has(privilegeId);

        if (isSelecting) {
            // ✅ Add all lower hierarchy
            for (let i = 0; i <= index; i++) {
                const id = getIdByName(CRUD_HIERARCHY[i]);
                if (id) next.add(id);
            }
        } else {
            // ❌ Remove current + higher
            // ❌ Special case: removing READ → wipe everything
            if (privName === 'READ') {
                return [];
            }

            // ❌ Remove current + higher (normal case)
            for (let i = index; i < CRUD_HIERARCHY.length; i++) {
                const id = getIdByName(CRUD_HIERARCHY[i]);
                if (id) next.delete(id);
            }
        }

        return Array.from(next);
    }

    // 🔥 EXPORT / SHARE → require READ
    if (privName === 'EXPORT' || privName === 'SHARE') {
        const isSelecting = !next.has(privilegeId);

        if (isSelecting) {
            next.add(privilegeId);
            const readId = getIdByName('READ');
            if (readId) next.add(readId);
        } else {
            next.delete(privilegeId);
        }

        return Array.from(next);
    }

    // 🔹 fallback
    if (next.has(privilegeId)) {
        next.delete(privilegeId);
    } else {
        next.add(privilegeId);
    }

    return Array.from(next);
}

// ---------------------------------------------------------------------------
// Disabled-state helper (pure)
// ---------------------------------------------------------------------------

/**
 * Returns true when a privilege checkbox should be disabled.
 * Enforces: WRITE needs READ, UPDATE needs READ+WRITE, DELETE needs READ+WRITE+UPDATE.
 */
function isPrivilegeDisabled(
    privName: string,
    selectedIds: string[],
    availableIds: string[],
    idToName: Map<string, string>
): boolean {

    const getName = (id: string) => idToName.get(id);

    const has = (name: string) =>
        selectedIds.some(id => getName(id) === name);

    if (privName === 'WRITE') return !has('READ');
    if (privName === 'UPDATE') return !(has('READ') && has('WRITE'));
    if (privName === 'DELETE') return !(has('READ') && has('WRITE') && has('UPDATE'));

    return false;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

const RoleModal: React.FC<RoleModalProps> = ({
    isOpen,
    onClose,
    onSubmit,
    initialData,
    title,
    modules = [],
    privileges = [],
}) => {
    const [step, setStep] = useState(1);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [selectedPermissions, setSelectedPermissions] = useState<Record<string, string[]>>({});
    const [errors, setErrors] = useState<{ name?: string; description?: string }>({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loadingRoleData, setLoadingRoleData] = useState(false);
    const [expandedModules, setExpandedModules] = useState<Record<string, boolean>>({});

    // ── Pre-compute O(1) lookup maps ────────────────────────────────────────
    /**
     * idToName: privilege ID → uppercase name  (e.g. "abc123" → "READ")
     * nameToId: uppercase name → privilege ID  (e.g. "READ" → "abc123")
     *
     * Memoised so the maps are only rebuilt when the `privileges` prop changes.
     */
const { idToName, nameToId } = useMemo(() => {
  const idToName = new Map<string, string>();
  const nameToId = new Map<string, string>();

  const normalize = (name: string) => {
    const upper = name.toUpperCase();
    if (upper === "CREATE") return "WRITE";
    return upper;
  };

  privileges.forEach(p => {
    const normalized = normalize(p.name);
    idToName.set(p.id, normalized);
    nameToId.set(normalized, p.id);
  });

  return { idToName, nameToId };
}, [privileges]);

    // ── Sorted privileges for display ───────────────────────────────────────
    const sortedPrivileges = useMemo(
        () =>
            [...privileges].sort((a, b) => {
                const oa = PRIV_DISPLAY_ORDER[a.name.toUpperCase()] ?? 50;
                const ob = PRIV_DISPLAY_ORDER[b.name.toUpperCase()] ?? 50;
                return oa - ob;
            }),
        [privileges],
    );

    // ── Reset / initialise on open ──────────────────────────────────────────
    useEffect(() => {
        if (isOpen && initialData) {
            setName(initialData.name);
            setDescription(initialData.description || '');
            if (initialData.id && privileges.length > 0) {
                loadRoleModules(initialData.id);
            }
        } else if (!isOpen) {
            setName('');
            setDescription('');
            setSelectedPermissions({});
            setExpandedModules({});
            setStep(1);
            setErrors({});
            setLoadingRoleData(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialData?.id, isOpen, privileges]);

    const loadRoleModules = async (roleId: string) => {
        setLoadingRoleData(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/roles/${roleId}/modules`,
                { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } },
            );
            if (!response.ok) return;

            const data = await response.json();
            const permMap: Record<string, string[]> = {};

            data.modules.forEach((m: any) => {
                // Map privilege names → IDs (using the pre-computed map)
const normalize = (name: string) => {
  const upper = name.toUpperCase();
  if (upper === "CREATE") return "WRITE";
  return upper;
};

const modulePrivIds = (m.privileges || [])
  .map((name: string) => nameToId.get(normalize(name)))
  .filter(Boolean) as string[];
                permMap[m.module_id] = modulePrivIds;

                (m.submodules || []).forEach((sub: any) => {
                   const subPrivIds = (sub.privileges || [])
  .map((name: string) => nameToId.get(normalize(name)))
  .filter(Boolean) as string[];

                    permMap[sub.submodule_id] = subPrivIds;
                });
            });

            setSelectedPermissions(permMap);
        } catch (error) {
            console.error('Failed to load role modules:', error);
        } finally {
            setLoadingRoleData(false);
        }
    };

    // ── Validation ──────────────────────────────────────────────────────────
    const validateName = (value: string): string | undefined => {
        if (!value.trim()) return 'Role name is required';
        if (value.trim().length > 50) return 'Role name cannot exceed 50 characters';
        return undefined;
    };

    const validateDescription = (value: string): string | undefined => {
        if (value.trim().length > 300) return 'Description cannot exceed 300 characters';
        return undefined;
    };

    const handleNameChange = (value: string) => {
        const upper = value.toUpperCase();
        setName(upper);
        setErrors(prev => ({ ...prev, name: validateName(upper) }));
    };

    const handleDescriptionChange = (value: string) => {
        setDescription(value);
        setErrors(prev => ({ ...prev, description: validateDescription(value) }));
    };

    const handleNext = () => {
        const nameError = validateName(name);
        if (nameError) { setErrors({ name: nameError }); return; }
        setErrors({});
        setStep(2);
    };

    const handleBack = () => setStep(1);

    const toggleModule = (moduleId: string) =>
        setExpandedModules(prev => ({ ...prev, [moduleId]: !prev[moduleId] }));

    // ── Core toggle — uses the pure helper above ────────────────────────────
    /**
     * @param targetId          module.id or submodule.id
     * @param privilegeId       The privilege being toggled, or "NO_ACCESS"
     * @param availablePrivIds  IDs valid for this specific target
     */
    const togglePermission = useCallback(
        (targetId: string, privilegeId: string, availablePrivIds: string[]) => {
            setSelectedPermissions(prev => {
                const current = prev[targetId] ?? [];
                const next = computeNextPrivileges(
    current,
    privilegeId,
    availablePrivIds,
    idToName
);

return { ...prev, [targetId]: next };
            });
        },
        [idToName],
    );

    // ── Submit ──────────────────────────────────────────────────────────────
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const nameError = validateName(name);
        if (nameError) { setErrors({ name: nameError }); setStep(1); return; }

        const modulePermissions: ModulePermission[] = [];

modules.forEach(module => {
    const isAdminOnly = ADMIN_ONLY_MODULES.has(module.name.toLowerCase());
    
    const modPrivIds = isAdminOnly
        ? sortedPrivileges.filter(p => (module.privileges || []).includes(p.name)).map(p => p.id)
        : (selectedPermissions[module.id] ?? []);

    modPrivIds.filter(pid => pid?.trim())
        .forEach(pid => modulePermissions.push({ module_id: module.id, privilege_id: pid }));

    module.submodules?.forEach(sub => {
        const subPrivIds = isAdminOnly
            ? sortedPrivileges.filter(p => (sub.privileges || []).includes(p.name)).map(p => p.id)
            : (selectedPermissions[sub.id] ?? []);

        subPrivIds.filter(pid => pid?.trim())
            .forEach(pid => modulePermissions.push({ module_id: module.id, submodule_id: sub.id, privilege_id: pid }));
    });
});

        setIsSubmitting(true);
        try {
            await onSubmit({
                name: name.trim(),
                description: description.trim(),
                modules: modulePermissions,
            });
        } finally {
            setIsSubmitting(false);
        }
    };
    const ADMIN_ONLY_MODULES = new Set(['profile']); // module.name values that must be admin-only
    // ── Render privilege checkboxes ─────────────────────────────────────────
    const renderPrivilegeCheckboxes = (targetId: string, availablePrivilegeNames: string[], moduleName?: string) => {
    const isAdminOnly = moduleName && ADMIN_ONLY_MODULES.has(moduleName.toLowerCase());
    
    // Auto-select all privileges (admin) for admin-only modules
    const selectedIds = isAdminOnly
        ? sortedPrivileges.filter(p => availablePrivilegeNames.includes(p.name)).map(p => p.id)
        : (selectedPermissions[targetId] ?? []);

    const available = sortedPrivileges.filter(p => availablePrivilegeNames.includes(p.name));
    const availableIds = available.map(p => p.id);
    const isNoAccess = selectedIds.length === 0;

    return (
        <div className={styles.checkboxGroup}>
            <label className={`${styles.checkboxLabel} ${isAdminOnly ? styles.checkboxLabelDisabled : ''}`}>
                <input
                    type="checkbox"
                    checked={isNoAccess}
                    // disabled={isAdminOnly}
                    onChange={() => !isAdminOnly && togglePermission(targetId, 'NO_ACCESS', availableIds)}
                    className={styles.checkboxInput}
                />
                <span className={styles.checkboxText}>No Access</span>
            </label>

            {available.map(priv => (
                <label
                    key={priv.id}
                    className={`${styles.checkboxLabel} ${isAdminOnly ? styles.checkboxLabelDisabled : ''}`}
                >
                    <input
                        type="checkbox"
                        checked={isAdminOnly || selectedIds.includes(priv.id)}
                        disabled={isAdminOnly || isPrivilegeDisabled(idToName.get(priv.id) ?? '', selectedIds, availableIds, idToName)}
                        onChange={() => {
                            if (isAdminOnly) return;
                            const privName = idToName.get(priv.id) ?? '';
                            const disabled = isPrivilegeDisabled(privName, selectedIds, availableIds, idToName);
                            if (!disabled) togglePermission(targetId, priv.id, availableIds);
                        }}
                        className={styles.checkboxInput}
                    />
                    <span className={styles.checkboxText}>{getPrivilegeLabel(priv.name)}</span>
                </label>
            ))}
        </div>
    );
};
    // const renderPrivilegeCheckboxes = (targetId: string, availablePrivilegeNames: string[]) => {
    //     const selectedIds = selectedPermissions[targetId] ?? [];

    //     // Scope available privileges to this module/submodule only
    //     const available = sortedPrivileges.filter(p => availablePrivilegeNames.includes(p.name));
    //     const availableIds = available.map(p => p.id);

    //     const isNoAccess = selectedIds.length === 0;

    //     return (
    //         <div className={styles.checkboxGroup}>
    //             {/* No Access */}
    //             <label className={styles.checkboxLabel}>
    //                 <input
    //                     type="checkbox"
    //                     checked={isNoAccess}
    //                     onChange={() => togglePermission(targetId, 'NO_ACCESS', availableIds)}
    //                     className={styles.checkboxInput}
    //                 />
    //                 <span className={styles.checkboxText}>No Access</span>
    //             </label>

    //             {available.map(priv => {
    //                 const privName = idToName.get(priv.id) ?? '';
    //                 const disabled = isPrivilegeDisabled(
    //                     privName,
    //                     selectedIds,
    //                     availableIds,
    //                     idToName,
    //                 );

    //                 return (
    //                     <label
    //                         key={priv.id}
    //                         className={`${styles.checkboxLabel} ${disabled ? styles.checkboxLabelDisabled : ''}`}
    //                     >
    //                         <input
    //                             type="checkbox"
    //                             checked={selectedIds.includes(priv.id)}
    //                             disabled={disabled}
    //                             onChange={() =>
    //                                 !disabled && togglePermission(targetId, priv.id, availableIds)
    //                             }
    //                             className={styles.checkboxInput}
    //                         />
    //                         <span className={styles.checkboxText}>{getPrivilegeLabel(priv.name)}</span>
    //                     </label>
    //                 );
    //             })}
    //         </div>
    //     );
    // };

    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.content} onClick={e => e.stopPropagation()}>
                <div className={styles.header}>
                    <h2>
                        {title} {`- Step ${step} of 2`}
                    </h2>
                    <button className={styles.closeButton} onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <form
                    className={styles.form}
                    onSubmit={handleSubmit}
                    onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}
                >
                    <div className={styles.formContent}>
                        {step === 1 && (
                            <>
                                <div className={styles.formGroup}>
                                    <label className={styles.label}>Role Name *</label>
                                    <input
                                        type="text"
                                        className={`${styles.input} ${styles.inputUppercase}`}
                                        value={name}
                                        onChange={e => handleNameChange(e.target.value)}
                                        required
                                        placeholder="Enter role name"
                                        maxLength={50}
                                        style={{ borderColor: errors.name ? '#ef4444' : '#d1d5db' }}
                                    />
                                    {errors.name && (
                                        <span className={styles.errorText}>{errors.name}</span>
                                    )}
                                    <span className={styles.charCount}>{name.length}/50 characters</span>
                                </div>

                                <div className={styles.formGroup}>
                                    <label className={styles.label}>Description</label>
                                    <textarea
                                        className={styles.textarea}
                                        value={description}
                                        onChange={e => handleDescriptionChange(e.target.value)}
                                        placeholder="Enter role description"
                                        maxLength={300}
                                        rows={4}
                                        style={{ borderColor: errors.description ? '#ef4444' : '#d1d5db' }}
                                    />
                                    {errors.description && (
                                        <span className={styles.errorText}>{errors.description}</span>
                                    )}
                                    <span className={styles.charCount}>
                                        {description.length}/300 characters
                                    </span>
                                </div>
                            </>
                        )}

                        {step === 2 && (
                            <div className={styles.moduleAssignment}>
                                <p className={styles.moduleHint}>
                                    Assign privileges to modules and submodules
                                </p>

                                {loadingRoleData ? (
                                    <div className={styles.loadingContainer}>
                                        <div className={styles.spinner} />
                                        <p>Loading role permissions...</p>
                                    </div>
                                ) : modules.length === 0 ? (
                                    <p className={styles.noModules}>No modules available</p>
                                ) : (
                                    <div className={styles.accordionContainer}>
                                        {modules.map(module => {
                                            const hasSubmodules =
                                                module.submodules && module.submodules.length > 0;
                                            const isExpanded = expandedModules[module.id];

                                            if (!hasSubmodules) {
                                                return (
                                                    <div key={module.id} className={styles.flatModuleItem}>
                                                        <div className={styles.flatModuleRow}>
                                                            <span className={styles.moduleLabel}>
                                                                {module.label}
                                                            </span>
                                                           {renderPrivilegeCheckboxes(module.id, module.privileges || [], module.name)}

                                                        </div>
                                                    </div>
                                                );
                                            }

                                            return (
                                                <div key={module.id} className={styles.accordionItem}>
                                                    <div
                                                        className={styles.accordionHeader}
                                                        onClick={() => toggleModule(module.id)}
                                                    >
                                                        <div className={styles.accordionTitle}>
                                                            <span className={styles.moduleLabel}>
                                                                {module.label}
                                                            </span>
                                                        </div>
                                                        <div className={styles.accordionArrow}>
                                                            {isExpanded ? (
                                                                <ChevronUp size={16} />
                                                            ) : (
                                                                <ChevronDown size={16} />
                                                            )}
                                                        </div>
                                                    </div>

                                                    {isExpanded && (
                                                        <div className={styles.accordionContent}>
                                                            <div className={styles.submoduleList}>
                                                                {module.submodules.map(sub => (
                                                                    <div
                                                                        key={sub.id}
                                                                        className={styles.submoduleItem}
                                                                    >
                                                                        <label
                                                                            className={styles.submoduleLabel}
                                                                        >
                                                                            {sub.label}
                                                                        </label>
                                                                       {renderPrivilegeCheckboxes(sub.id, sub.privileges || [], module.name)}

                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    <div className={styles.actions}>
                        {step === 2 && (
                            <button
                                type="button"
                                className={styles.backButton}
                                onClick={handleBack}
                            >
                                <ChevronLeft size={16} color="#64748b" /> Back
                            </button>
                        )}
                        <button type="button" className={styles.cancelButton} onClick={onClose}>
                            Cancel
                        </button>
                        {step === 1 ? (
                            <button
                                type="button"
                                className={styles.nextButton}
                                onClick={e => { e.preventDefault(); handleNext(); }}
                                disabled={!name.trim() || !!errors.name}
                            >
                                Next <ChevronRight size={16} color="#011926" />
                            </button>
                        ) : (
                            <button
                                type="submit"
                                className={styles.submitButton}
                                disabled={isSubmitting || loadingRoleData}
                            >
                                {isSubmitting ? 'Saving...' : initialData ? 'Update' : 'Create'}
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RoleModal;
